import React from "react";
import Page from "../../../_components/Layout/Page";
import Row from "../../../_components/Layout/Row";
import Column from "../../../_components/Layout/Column";
import Text from "../../../_components/Text";
import TableData from "../../../_components/TableData";
import Button from "../../../_components/Button";
import Modal from "../../../_components/Modal";
import UploadCertificate from "./components/UploadCertificate";
import { formatDate } from "../../../utils";
import { getCertificates } from "../../../api/digitalCertificates";

export default (props) => {
  const [show, setShow] = React.useState(false);
  const tableRef = React.useRef(null);
  const [data, setData] = React.useState([]);
  const [onSucces, setSuccess] = React.useState(false);
  const [onSuccesTextHeader, setSuccesTextHeader] = React.useState("");
  const [onSuccesTextHeaderBody, setSuccesTextHeaderBody] =
    React.useState(false);

  const handleSuccess = (header, body) => {
    setShow(false);
    setTimeout(() => {
      setSuccesTextHeader(header);
      setSuccesTextHeaderBody(body);
      setSuccess(true);
    }, 250);
    console.debug(header, body);
  };

  const handleCloseModal = () => {
    setShow(false);
  };

  React.useEffect(() => {
    getCertificates().then((resp) => {
      setData(
        resp.map((item) => {
          let date = new Date(item.expiry_date);
          date = new Date(
            date.setHours(date.getHours() - 3)
          ).toLocaleDateString("pt-BR", {
            year: "numeric",
            month: "numeric",
            day: "numeric",
            hour: "2-digit",
            minute: "2-digit",
          });
          return {
            uploaded_date: formatDate(item.uploaded_date),
            expiry_date: date,
            type: "A1",
          };
        })
      );
    });
  }, [tableRef.current]);

  return (
    <Page title="Certificado Digital">
      <Row>
        <Column col="12">
          <Text fontSize="lg" color="primary"></Text>
          <Text fontSize="sm" color="primary">
            Se você ainda não possui, clique no botão abaixo e aproveite a nossa
            oferta exclusiva!
          </Text>
        </Column>
        <Column col="12" ref={tableRef}>
          <TableData
            tHead={["Data de cadastro", "Vencimento", "Tipo de Certificado"]}
            tBodyKeys={["uploaded_date", "expiry_date", "type"]}
            data={data}
          />
        </Column>
        <Column col="12" className="d-flex justify-content-center">
          <Button onClick={() => setShow(true)}>Importar Certificado</Button>
        </Column>
      </Row>
      <Modal
        title="Cadastrar Certificado Digital"
        show={show}
        onHide={handleCloseModal}
      >
        <UploadCertificate handleSuccess={handleSuccess} />
      </Modal>
      <Modal show={onSucces} title="Certificado digital anexado">
        <Text fontSize="md" align="center">
          {onSuccesTextHeader}
        </Text>
        <Text fontSize="md" align="center">
          {onSuccesTextHeaderBody}
        </Text>
        <div className="d-flex justify-content-center">
          <Button onClick={() => window.location.reload()}>Ok</Button>
        </div>
      </Modal>
    </Page>
  );
};



// WEBPACK FOOTER //
// ./src/views/AppViews/DigitalCertificate/index.jsx